export const ButtonAppearance = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  DESTRUCTIVE_PRIMARY: 'destructive-primary',
  DESTRUCTIVE_SECONDARY: 'destructive-secondary',
  DESTRUCTIVE_TERTIARY: 'destructive-tertiary',
} as const;
export type TButtonAppearance = TValueOf<typeof ButtonAppearance>;

export const ButtonSize = {
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
} as const;
export type TButtonSize = TValueOf<typeof ButtonSize>;

export interface IButtonProps extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  title?: string;
  children?: React.ReactNode;
  //
  disabled?: boolean;
  loading?: boolean;
  stretched?: boolean;
  appearance?: TButtonAppearance;
  size?: TButtonSize;
  //
  spinnerColor?: string;
  style?: React.CSSProperties;
  className?: string;
  titleClassName?: string;
}

export type TButtonStyle = Pick<IButtonProps, 'stretched' | 'appearance' | 'size' | 'className' | 'loading' | 'disabled'>;

export type TButtonSpinnerColor = Pick<IButtonProps, 'appearance' | 'spinnerColor'>;
